const images = 
    {
        donut : "https://media.istockphoto.com/photos/donut-with-sprinkles-isolated-picture-id538335769?k=20&m=538335769&s=612x612&w=0&h=A1DAZd6aHjfRyq2qKAKuBD9KAf0cq1LXKW8mpvTxKgU=",
        flower : "https://cdn.pixabay.com/photo/2015/04/19/08/33/flower-729512__340.jpg",
        butterfly : "https://natureconservancy-h.assetsadobe.com/is/image/content/dam/tnc/nature/en/photos/shutterstock_1512536354.jpg?crop=0%2C317%2C2664%2C1465&wid=4000&hei=2200&scl=0.666",
        happy_sad_face : "http://cdn.shopify.com/s/files/1/0641/1521/products/patches-smiley-face-happy-sad-venn.jpg?v=1613156051",
        ice_cream : "https://img.freepik.com/free-vector/ice-cream-cone-cartoon-icon-illustration-sweet-food-icon-concept-isolated-flat-cartoon-style_138676-2924.jpg?w=360",
        thumbs_up : "https://illustoon.com/photo/4292.png",
        heart : "https://www.pngitem.com/pimgs/m/595-5957528_black-heart-symbol-outline-love-heart-png-transparent.png"
    }

export default images
